// extracted by mini-css-extract-plugin
export var editInput = "_h8-0";
export var editInputCompact = "_h8-2";
export var editInputLarge = "_h8-1";
export var editInputSmall = "_h8-3";